import { useState, useEffect } from 'react';
import { initialTestimonials } from '../data/testimonials';

const STORAGE_KEY = 'centro-volantin-testimonials';

export const useLocalTestimonials = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);

  // Cargar testimonios del localStorage o usar los iniciales
  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      try {
        setTestimonials(JSON.parse(stored));
      } catch (error) {
        console.error('Error al cargar testimonios:', error);
        setTestimonials(initialTestimonials);
      }
    } else {
      setTestimonials(initialTestimonials);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(initialTestimonials));
    }
    setLoading(false);
  }, []);

  // Guardar testimonios en localStorage
  const saveTestimonials = (newTestimonials) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(newTestimonials));
    setTestimonials(newTestimonials);
  };

  // Agregar nuevo testimonio
  const addTestimonial = (testimonial) => {
    const newTestimonial = {
      ...testimonial,
      id: Date.now(),
      date: new Date().toISOString().split('T')[0]
    };
    const updatedTestimonials = [...testimonials, newTestimonial];
    saveTestimonials(updatedTestimonials);
  };

  // Eliminar testimonio
  const deleteTestimonial = (id) => {
    const updatedTestimonials = testimonials.filter(t => t.id !== id);
    saveTestimonials(updatedTestimonials);
  };

  // Calcular promedio de calificaciones
  const averageRating = testimonials.length > 0 
    ? (testimonials.reduce((sum, t) => sum + t.rating, 0) / testimonials.length).toFixed(1)
    : 0;

  return {
    testimonials,
    loading,
    addTestimonial,
    deleteTestimonial,
    averageRating
  };
};
